import LightThemeImage from "../../../../../assets/Images/Setting/Preference/LightThemeImage.png";
import DarkThemeImage from "../../../../../assets/Images/Setting/Preference/DarkThemeImage.png";
import "../../../../../styles/ComponentsStyles/Setting/Preference/Theme/Theme.style.css";
import { useState } from "react";
const Theme = () => {
  const [themeSet, setThemeSet] = useState("dark");
  return (
    <div className="flex-col flex-1 w-full  radius-10 back-white  align-left justify-start  pt-2 pb-2 pl-3 pr-3 g-2">
      <h3 className="t-16 color-grayColor poppins-medium weight-500">
        Theme set
      </h3>
      <div className="w-full flex-1 overflow-hide flex-row align-center justify-center">
        <div className="themeChangeInputSelectorParentContainer p-1 radius-6 overflow-hide relative flex-col align-center justify-center g-1">
          <div className="p-1 radius-10 themeChangeImageParentContainer">
            <img
              src={LightThemeImage}
              alt="light theme"
              style={{ width: "15vw", objectFit: "cover" }}
            />
          </div>
          <span className="color-grayColor poppins-medium t-14">
            Light mode
          </span>
          <input
            type="radio"
            name="themechange"
            className="themeChangeInputSelector"
            value={"light"}
            checked={themeSet === "light"}
            onChange={(e) => setThemeSet(e.target.value)}
          />
        </div>
        <div className="themeChangeInputSelectorParentContainer p-1 radius-6 overflow-hide relative flex-col align-center justify-center g-1">
          <div className="p-1 radius-10 themeChangeImageParentContainer">
            <img
              src={DarkThemeImage}
              alt="light theme"
              style={{ width: "15vw", objectFit: "cover" }}
            />
          </div>
          <span className="color-grayColor poppins-medium t-14">Dark mode</span>
          <input
            type="radio"
            name="themechange"
            value={"dark"}
            className="themeChangeInputSelector"
            checked={themeSet === "dark"}
            onChange={(e) => setThemeSet(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Theme;
